<template>
  <div class="question-box">
    <div class="question-holder">
      <h5 class="question-label">{{ label }}</h5>
      <div>
        <select
          v-if="type == 'select'"
          ref="inputField"
          :class="{
            'custom-select custom-select-lg': true,
            'is-invalid': error,
          }"
          v-model="localValue"
          v-on:keyup.enter="submit"
          @change="itemSelected"
        >
          <option disabled value="">{{ placeHolder }}</option>
          <option v-for="(option, key) in options" :key="key" :value="key">
            {{ option }}
          </option>
        </select>
        <input
          v-if="type == 'tel'"
          ref="inputField"
          type="text"
          maxlength="12"
          v-model="localValue"
          :class="{ 'form-control fieldHeight': true, 'is-invalid': error }"
          :placeholder="placeHolder"
          @keypress="acceptableKeysPhone($event)"
          v-on:keyup.enter="submit"
        />
        <input
          v-if="type == 'zipcode'"
          ref="inputField"
          type="text"
          maxlength="12"
          v-model="localValue"
          :class="{ 'form-control fieldHeight': true, 'is-invalid': error }"
          :placeholder="placeHolder"
          @keypress="acceptableKeysZipcode($event)"
          v-on:keyup.enter="submit"
        />
        <input
          v-if="type == 'name'"
          ref="inputField"
          type="text"
          maxlength="40"
          v-model="localValue"
          :class="{ 'form-control fieldHeight': true, 'is-invalid': error }"
          :placeholder="placeHolder"
          v-on:keyup.enter="submit"
        />
        <input
          v-if="type == 'text'"
          ref="inputField"
          type="text"
          maxlength="80"
          v-model="localValue"
          :class="{ 'form-control fieldHeight': true, 'is-invalid': error }"
          :placeholder="placeHolder"
          v-on:keyup.enter="submit"
        />
        <div v-if="error" class="invalid-feedback">
          {{ errMsg }}
        </div>
      </div>
    </div>
    <div class="button-holder">
      <button @click="submit" class="btn customBtn">
        <span v-if="!lastStep">Continue <i class="bi bi-arrow-right-circle"></i></span>
        <span v-if="lastStep">Get Free Guide</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "value",
    "lastStep",
    "label",
    "placeHolder",
    "options",
    "errMsg",
    "type",
    "required"
  ],
  watch: { 
    value: function(newVal) {
      this.localValue = newVal
    }
  },
  data() {
    return {
      error: false,
      localValue: this.value ? this.value : ''
    };
  },
  methods: {
    submit: function () {
      if (!this.localValue && this.required) {
        this.error = true;
      } else {
        if ((this.type == 'tel' && !this.isValidPhone()) || (this.type == 'zipcode' && !this.isValidZipcode()) || (this.type == 'name' && !this.isValidFullName())) {
          this.error = true;
        } else {
          if (this.type == 'name') {
            let url = 'https://www.purgomalum.com/service/containsprofanity?text=';
            fetch(url + this.localValue)
              .then(response => response.text())
              .then(response => {
                if (response == 'true') {
                  this.$emit("submit", 'Client Mutual');
                } else {
                  this.$emit("submit", this.localValue);
                }
              })
              .catch(error => {
                console.log(error);
                this.$emit("submit", this.localValue);
              });

          } else {
            this.$emit("submit", this.localValue);
          }
        }
      }
    },
    itemSelected: function () {
      if (this.localValue) {
        this.submit();
      }
    },
    acceptableKeysPhone: function (event) {
      let keysAllowed = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ")",
        "(",
        "-"
      ];
      let keyPressed = event.key;
      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault();
      }
    },
    acceptableKeysZipcode: function (event) {
      let keysAllowed = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9"
      ];
      let keyPressed = event.key;
      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault();
      }
    },
    isValidPhone: function () {
      let regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      return regex.test(this.localValue);
    },
    isValidZipcode: function () {
      let regex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
      return regex.test(this.localValue)
    },
    isValidFullName: function () {
      let regex = /^(([A-Za-z0-9]+[-']?)*([A-Za-z0-9]+)?\s)+([A-Za-z0-9]+[-']?)*([A-Za-z0-9]+)+$/;
      return regex.test(this.localValue)
    },

  }
};
</script>
